require("./lib/social");
require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

// kick off page load effects
document.body.classList.add("loaded");

require("./science");
require("./menu");
require("./carousel");
require("./pitch-animation");